import React from "react";
import { motion } from "framer-motion";

export function Widget({ children, className = "", delay = 0, testId }) {
  return (
    <motion.div
      data-testid={testId}
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
      className={`tcc-card p-6 ${className}`}
    >
      {children}
    </motion.div>
  );
}

export function WidgetHeader({ icon: Icon, title, action }) {
  return (
    <div className="flex items-center justify-between mb-5">
      <div className="flex items-center gap-2.5">
        {Icon && (
          <div className="h-9 w-9 rounded-xl bg-primary/12 flex items-center justify-center">
            <Icon className="text-primary" size={18} strokeWidth={1.7} />
          </div>
        )}
        <h3 className="font-heading font-bold text-slate-800">{title}</h3>
      </div>
      {action}
    </div>
  );
}

export function EmptyState({ children }) {
  return <p className="text-sm text-slate-400 py-4 text-center">{children}</p>;
}
